import { Record } from 'immutable'

export interface IFeedItemToken {
  readonly id: string
  readonly isUser: boolean
  readonly name: string
  readonly type: string
  getImageUrl: () => string
}

interface IFeedItemTokenCompact {
  i: string
  n: string
  t: string
  u: boolean
}

const FeedItemTokenRecord = Record({
  id: '',
  isUser: false,
  name: '',
  type: '',
})

export class FeedItemToken extends FeedItemTokenRecord
  implements IFeedItemToken {
  public static fromJS(initialState: Partial<IFeedItemTokenCompact>) {
    return initialState
      ? new FeedItemToken({
          id: initialState.i,
          isUser: initialState.u,
          name: initialState.n,
          type: initialState.t,
        })
      : new FeedItemToken()
  }

  public readonly id: string
  public readonly isUser: boolean
  public readonly name: string
  public readonly type: string

  constructor(props?: Partial<IFeedItemToken>) {
    props ? super(props) : super()
  }

  public getImageUrl(): string {
    switch (this.type) {
      case 'C':
        return `/api/Contacts/${this.id}/ProfileImage?h=50&w=50`

      case 'S':
        return '/images/HBlogo_Square_Image_Only.png'

      default:
        return `/api/Properties/${this.id}/ThumbnailImage?h=50&w=50`
    }
  }
}
